module.exports = __webpack_public_path__ + "img/no_source.7ff8a56b.svg";